export class observer {
  //上下文
  context: any = null;
  //回调
  callback: Function = null;
  constructor(callback: Function, context: any) {
    let self = this;
    self.callback = callback;
    self.context = context;
  }
  public Nofity(...args: any[]): void {
    let self = this;
    self.callback.call(self.context, ...args);
  }
  public Compare(context: any): boolean {
    return this.context == context;
  }
}
